import { useState, useEffect, useCallback } from 'react';
import { Box } from '@mui/material';

import { useAppDispatch } from 'hooks/useRedux';
import { getCustomerLogReporting } from 'store/reducer/workflowReducer/action';

import Loader from 'components/loader';
import CommunicationLogsTable from './table';
import LogFilter from './filters/logFilter';
import CommunicationLogHeader from './commHeader';

export type DateType = { start: Date | null; end: Date | null };

const WorkflowCommunicationLogs = () => {
  const [loading, setLoading] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({
    days: 7,
    custom_channels: [],
    custom_modules: [],
    status: [],
    direction: [],
    receiver: '',
    sender_module: 'campaign',
    sender_name: '',
  });

  const [dates, setDates] = useState<DateType>({
    start: null,
    end: null,
  });

  const dispatch = useAppDispatch();

  const getCustomerLogs = useCallback(
    async (filters?: any) => {
      try {
        setLoading(true);
        const payload = filters ?? { days: selectedFilters.days };
        await dispatch(getCustomerLogReporting(payload));
      } finally {
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch]
  );

  useEffect(() => {
    getCustomerLogs();
  }, [getCustomerLogs]);

  const onApply = async () => {
    try {
      let payload: any = { ...selectedFilters };
      for (const [key, value] of Object.entries(payload)) {
        if (Array.isArray(value)) {
          if (value.length) {
            payload[key] = JSON.stringify(value);
          } else {
            delete payload[key];
          }
        } else {
          if (value === '') delete payload[key];
        }
      }
      if (!selectedFilters.days && dates.start && dates.end) {
        payload.dates = JSON.stringify([dates.start, dates.end]);
        delete payload.days;
      }
      if (payload.sender_name) {
        const senderData = [payload.sender_module, payload.sender_name];
        payload.sender_name = JSON.stringify(senderData);
        delete payload.sender_module;
      } else {
        delete payload.sender_module;
      }
      getCustomerLogs(payload);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <Loader loading={loading} />
      <Box sx={{ padding: '1rem 2rem 1rem 3rem' }}>
        <CommunicationLogHeader />

        <LogFilter
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          onApply={onApply}
          dates={dates}
          setDates={setDates}
        />

        <CommunicationLogsTable />
      </Box>
    </>
  );
};

export default WorkflowCommunicationLogs;
